import React from 'react'
import { Box, Divider, Grid,Typography } from "@mui/material";
// import Grid from "@mui/material/Grid2";
interface LicenseModalTabOneProps {
  selectedRow: any; 
  licenseDetailsAll:any
}
const LicenseModalTabOne: React.FC<LicenseModalTabOneProps> = ({ selectedRow ,licenseDetailsAll}) => {
  console.log(licenseDetailsAll)
  function convertTimestampToDate(timestamp: number): string {
    const formattedDate = new Date(timestamp).toLocaleString();
    return formattedDate.replace(',', '  |');
  }
  return (
    <Box
      sx={{
        // backgroundColor: "#1a2a2f",
        color: "#B4B7B8",
        padding: 4,
        borderRadius: 2,
      }}
    >
      <Grid container spacing={2}>
        {/* Feature Section */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#ffffff" }}>
            Feature
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>Feature: {licenseDetailsAll.license?.data?.name}</Typography>

        </Grid>
        <Grid item xs={6}>
          <Typography>License Type: {licenseDetailsAll.license?.data?.licenseType} Year{licenseDetailsAll.license?.data?.licenseType>1 ? "s" : ""}</Typography>

        </Grid>

        {/* Feature Usage Section */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#ffffff" }}>
          Feature Usage
          </Typography>
        </Grid>
        <Grid item xs={6}>

          <Typography>Expiry Date: {convertTimestampToDate(licenseDetailsAll.license?.data.expiryTime)}</Typography>
          <Typography>Created on: {convertTimestampToDate(licenseDetailsAll.license?.data.createdTime)}</Typography>
          {/* <Typography>Last Checked: -</Typography> */}
        </Grid>
        <Grid item xs={6}>
          
          <Typography>Validity Period: 
            {licenseDetailsAll.license?.data?.licenseType} Year{licenseDetailsAll.license?.data?.licenseType>1 ? "s" : ""}
            {licenseDetailsAll.license?.data?.status === 0 && <span style={{color: "yellow", fontWeight: "bold", marginLeft:"20px" }}>● Suspended</span>}
            {licenseDetailsAll.license?.data?.status === 1 && <span style={{color: "green", fontWeight: "bold", marginLeft:"20px" }}>● Active</span>}
          </Typography>
          <Typography>Activated on: {convertTimestampToDate(licenseDetailsAll.license?.data.activationTime)}</Typography>
          {/* <Typography>Last Updated: Jan 05 2024 | 08:05 PM</Typography> */}
        </Grid>

        {/* Other Section */}
        {/* <Grid item xs={12}>

        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#ffffff" }}>
            Other
          </Typography>
          </Grid>
        <Grid item xs={6}>
 
          <Typography>Max Activations: 1</Typography>
          <Typography>Transfer Count: 0</Typography>
          <Typography>Authorization Method: License Key</Typography>
          <Typography>Note: -</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>Times Activated: 0</Typography>
          <Typography>Is Trial: No</Typography>
          <Typography>Prevent Virtual Machine: No</Typography>
          <Typography>Metadata: {`"metadata": {}`}</Typography>
        </Grid> */}
      </Grid>
    </Box>
  )
}

export default LicenseModalTabOne